export const fetchSrtBrandImageAsBase64 = async () => {
    const response = await fetch(process.env.REACT_APP_SRT_BLACK_BRAND);
    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const addCompanyHeader = async (worksheet, title = 'Sales Agent Transactions Report', startDate, endDate) => {
    // Add image to header

    const SeaRoadBrandBase64 = await fetchSrtBrandImageAsBase64();

    const logo = worksheet.workbook.addImage({
        base64: SeaRoadBrandBase64,
        extension: 'png',
    });

    worksheet.addImage(logo, {
        tl: { col: 0, row: 0 },
        ext: { width: 400, height: 100 },  // Adjust size of the logo
    });

    // Add company info below the image
    worksheet.getCell('F1').value = 'SEA ROAD TRADING INC.';
    worksheet.getCell('F1').font = { bold: true, size: 16 }; // Bold and size 16px

    worksheet.getCell('E2').value = 'Gochan Compound, Warehouse 5B, MJ Cuenco Avenue, Mabolo, Cebu City, Philippines';
    worksheet.getCell('E3').value = 'Telephone No.: (032) 434-6453 | TIN#: 274-454-701-000';

    worksheet.getCell('F8').value = title;
    worksheet.getCell('F8').font = { bold: true, size: 20 }; // Bold and size 20px

    worksheet.getCell('A10').value = `Start Date: ${startDate}`;
    worksheet.getCell('A11').value = `End Date: ${endDate}`;
};
